import React from 'react';
import { createRoot } from 'react-dom/client';
import Reviews from './components/Reviews.jsx';
import ReviewsOverview from './components/ReviewsOverview.jsx';

// Function to initialize React components
const initializeReactComponents = () => {
  // Mount Reviews component
  const reviewsContainer = document.getElementById('reviews-react');
  if (reviewsContainer) {
    const root = createRoot(reviewsContainer);
    
    // Get configuration from data attributes
    const apiEndpoint = reviewsContainer.dataset.apiEndpoint || '/api/reviews';
    const limit = parseInt(reviewsContainer.dataset.limit) || 6;
    
    root.render(<Reviews apiEndpoint={apiEndpoint} limit={limit} />);
  }

  // Mount the paginated reviews overview (can appear more than once per page)
  document
    .querySelectorAll('[data-react="reviews-overview"]')
    .forEach((container) => {
      const root = createRoot(container);

      const apiEndpoint = container.dataset.apiEndpoint || '/api/reviews';
      const perPage = parseInt(container.dataset.perPage) || 20;

      root.render(
        <ReviewsOverview apiEndpoint={apiEndpoint} perPage={perPage} />
      );
    });
};

// Export for use in main index.js
export { initializeReactComponents };
